import { Typography } from "@mui/material";
import { InvalidRouteBase } from "features/shell";

export default function NoProjectFound() {
  return (
    <InvalidRouteBase>
      <Typography>
        Your link may be broken or the project may have been removed.
      </Typography>
    </InvalidRouteBase>
  );
}
